const OwnershipView={
  HoldingRank:1,
  SharesHeld:2,
  SharesChange:3
}
export default OwnershipView;
